import { useEffect } from "react";

function UniTable({
  uniData,
  setFavDepartments,
  favoriteDepartmentTrigger,
  setFavoriteDepartmentTrigger,
}) {
  // Favori üniversiteleri localStorage'da saklamak için anahtar
  const localStorageKey = "favoriteUniversities";

  // Favori üniversite eklemek için fonksiyon
const addFavoriteUniversity = (university) => {
  const storedFavorites = localStorage.getItem(localStorageKey);
  const favorites = storedFavorites ? JSON.parse(storedFavorites) : [];

  // Kontrol etmek için nesnenin benzersiz bir özelliğini kullanabilirsiniz, örneğin ID
  const isDuplicate = favorites.some(
    (item) => item.uni_department === university.uni_department
  );

  if (!isDuplicate) {
    favorites.push(university);
    localStorage.setItem(localStorageKey, JSON.stringify(favorites));
    setFavoriteDepartmentTrigger(favoriteDepartmentTrigger + 1);
  }
};


  useEffect(() => {
    const storedFavorites = localStorage.getItem(localStorageKey);
    if (storedFavorites) {
      setFavDepartments(JSON.parse(storedFavorites));
    }
  }, [favoriteDepartmentTrigger]);

  return (
    <>
      <table className="main-table table table-dark table-striped">
        <thead>
          <tr>
            <th scope="col">#</th>
            <th scope="col">Bölüm</th>
            <th colSpan="3">Detaylar</th>
            <th scope="col"> </th>
          </tr>
          <tr>
            <th scope="col"></th>
            <th scope="col"></th>
            <th scope="col">Kota</th>
            <th scope="col">Puan</th>
            <th scope="col">Sıralama</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          {uniData.map((university, index) => (
            <tr key={index}>
              <th scope="row">{index + 1}</th>
              <td>{university.uni_department}</td>
              <td>{university.quota}</td>
              <td>{university.p2022}</td>
              <td>{university.s2022}</td>
              <td>
                <button
                  onClick={() => addFavoriteUniversity(university)}
                  className="btn btn-success"
                >
                  +
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}

export default UniTable;
